<template>
  <div class="hulu-course-carousel">
    <div class="hulu-course-caoursel__links">
      <div class="hulu-course-carousel__link">
        <h3 class="hulu-course-carousel__carousel-title">
          <i class="material-icons hulu-course-carousel__carousel-icon">{{
            icon
          }}</i>
          {{ title }}
        </h3>
        <router-link
          v-if="route"
          class="hulu-course-carousel__view-all"
          :to="{ name: 'allCourses', params: { name: route } }"
        >
          View All
          <span class="material-icons hulu-course-carousel__more-icon"
            >arrow_right</span
          >
        </router-link>
      </div>
    </div>
    <div class="hulu-course-carousel__carousel-wrapper">
      <router-link
        v-if="featured && featured.length !== 0"
        :to="{
          name: 'course',
          params: { id: featured.id, slug: featured.slug },
        }"
        class="hulu-course-carousel__featured"
      >
        <div
          class="hulu-course-carousel__featured-tile"
          :style="
            `background-image: url(${$getCourseBackground(
              featured,
              'medium'
            )}), linear-gradient(${$getGradient()})`
          "
        >
          <div class="hulu-course-carousel__featured-overlay"></div>

          <div>
            <div class="hulu-course-carousel__featured-title">
              {{ featured.title }}
            </div>
          </div>
          <div class="hulu-course-carousel__featured-instructor">
            <img
              class="hulu-course-carousel__featured-instructor-img"
              :src="featured.presenter.image"
            />
            <div class="hulu-course-carousel__featured-instructor-name-wrapper">
              <p class="hulu-course-carousel__featured-instructor-lead">
                Instructor
              </p>
              <p class="hulu-course-carousel__featured-instructor-name">
                {{ featured.presenter.full_name }}
              </p>
            </div>
            <div class="hulu-course-carousel__featured-branding">
              {{ featured.track.vendor.title }}
            </div>
          </div>
        </div>
      </router-link>
      <swiper
        class="swiper-container hulu-course-carousel__stacked-carousel"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="course in carouselCourses"
          :key="course.id"
          class="swiper-slide hulu-course-carousel__tile"
          :style="
            `background-image: url(${$getCourseBackground(
              course,
              'small'
            )}), linear-gradient(${$getGradient()})`
          "
        >
          <router-link
            :to="{
              name: 'course',
              params: { id: course.id, slug: course.slug },
            }"
            class="hulu-course-carousel__course-link"
          >
            <div class="hulu-course-carousel__overlay"></div>
            <div class="hulu-course-carousel__details">
              <div class="hulu-course-carousel__title">{{ course.title }}</div>
              <div class="hulu-course-carousel__instructor">
                <div class="hulu-course-carousel__name-wrapper">
                  <p class="hulu-course-carousel__lead">Instructor</p>
                  <p class="hulu-course-carousel__name">
                    {{ course.presenter.full_name }}
                  </p>
                </div>
                <div class="hulu-course-carousel__branding">
                  {{ course.track.vendor.title }}
                </div>
              </div>
            </div>
          </router-link>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev">
          <i class="material-icons left-advance-carousel"
            >keyboard_arrow_left</i
          >
        </div>
        <div class="swiper-button-next" slot="button-next">
          <i class="material-icons right-advance-carousel"
            >keyboard_arrow_right</i
          >
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'HuluCourseCarousel',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,
        freeMode: false,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled',
        },
      },
    }
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    route: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    windowWidth: {
      type: Number,
      required: true,
    },
  },
  computed: {
    featured() {
      return this.courses[0]
    },
    carouselCourses() {
      if (this.windowWidth >= 1441) {
        return this.courses.slice(1, 21)
      }
      return this.courses.slice(0, 21)
    },
  },
}
</script>

<style lang="scss" scoped>
.hulu-course-carousel {
  margin-bottom: 80px;
  &__link {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__carousel-title {
    color: var(--white);
    font-size: 1.3rem;
    padding: 0;
    margin: 0;
  }
  &__carousel-icon {
    color: var(--orange);
    font-size: 1.7rem;
    margin-right: 5px;
  }
  &__view-all {
    color: var(--white);
    padding: 5px 20px;
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: space-between;
    transition: 0.5s all ease;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      color: var(--orange);
      text-decoration: none;
    }
  }
  &__more-icon {
    font-size: 1.5rem;
    color: var(--orange);
    transition: 0.5s all ease;
  }
  &__carousel-wrapper {
    display: flex;
    justify-content: space-between;
  }
  &__featured {
    display: none;
    padding: 15px;
    padding-right: 0px;
    background-color: var(--light-gray);
    @media screen and (min-width: 1440px) {
      display: block;
    }
  }
  &__featured-tile {
    height: 470px;
    width: 750px;
    padding: 40px;
    padding-right: 15px;
    padding-bottom: 0px;
    color: var(--white);
    background-color: var(--orange);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    position: relative;
    &:hover {
      cursor: pointer;
      .hulu-course-carousel__featured-overlay {
        opacity: 1;
      }
    }
  }
  &__featured-overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__featured-title {
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    width: 350px;
    padding-top: 25px;
  }

  &__featured-instructor {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
  }
  &__featured-instructor-img {
    width: 100px;
    border-radius: 100%;
    margin-right: 15px;
    margin-bottom: 25px;
  }
  &__featured-instructor-name-wrapper {
    width: 75%;
    padding-bottom: 25px;
  }
  &__featured-instructor-lead {
    font-size: 1rem;
    color: lightgray;
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 500;
  }
  &__featured-instructor-name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
    font-size: 1.5rem;
  }
  &__featured-branding {
    font-weight: 700;
    font-size: 1rem;
    text-transform: uppercase;
    width: 20%;
    margin-bottom: -20px;
  }
  &__stacked-carousel {
    padding: 15px;
    padding-left: 10px;
    background-color: var(--light-gray);
    @media (max-width: 1440px) {
      min-width: 100%;
    }
  }
  &__tile {
    text-align: left;
    padding: 15px;
    width: 375px !important;
    height: 200px;
    color: var(--white);
    background-color: var(--orange);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    z-index: 1;
    &:hover {
      cursor: pointer;
      .hulu-course-carousel__overlay {
        opacity: 1;
      }
    }
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__course-link {
    text-decoration: none;
    color: var(--white);
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    &:hover {
      color: var(--white);
      text-decoration: none;
      .hulu-course-carousel__overlay {
        opacity: 1;
      }
    }
  }
  &__details {
    padding: 20px;
    padding-top: 30px;
    padding-right: 10px;
    padding-bottom: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__title {
    font-size: 1.2rem;
    font-weight: 700;
    width: 200px;
  }
  &__instructor {
    display: flex;
    justify-content: space-between;
  }
  &__name-wrapper {
    padding-bottom: 20px;
  }
  &__lead {
    color: lightgray;
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 500;
  }
  &__name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
  }
  &__branding {
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    align-self: flex-end;
    padding-bottom: 5px;
  }

  .swiper-button-next,
  .swiper-button-prev {
    background: none;
  }
  .swiper-button-next {
    right: 40px !important;
  }
  .swiper-button-disabled {
    display: none;
  }
}
</style>
